// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"styles_wrapper__3lKKB","content":"styles_content__3w77f","header":"styles_header__1CSS3","back":"styles_back__ARJj2","container":"styles_container__KGEn1"};